<div class="dialog-container" [formGroup]="model">

  <!-- Seção fixa: filtros -->
  <div class="dialog-fixed">

    <!-- Filtros -->
    <div class="row">

      <!-- Botão período -->
      <div class="col-6 col-sm-4">
        <button #periodoMenuTrigger="matMenuTrigger" mat-stroked-button type="button" class="btn-periodo"
          [matMenuTriggerFor]="periodoMenu" (menuOpened)="prepararPeriodoIntervalo()"
          [class.btn-periodo--ativo]="periodoSelecionado !== periodoBuscaEnum.Ultimos30Dias">
          {{ periodoLabel }}
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>

        <mat-menu #periodoMenu="matMenu" class="periodo-custom-menu" (closed)="onPeriodoMenuClosed()">
          <div class="periodo-menu-content">
            <div>
              <button type="button" class="periodo-menu-item"
                (click)="selecionarPeriodo(periodoBuscaEnum.Hoje); aplicarPeriodo()"
                [class.periodo-item-selecionado]="periodoSelecionado === periodoBuscaEnum.Hoje">
                <span>hoje</span>
                @if (periodoSelecionado === periodoBuscaEnum.Hoje) { <mat-icon>check</mat-icon> }
              </button>
              <button type="button" class="periodo-menu-item"
                (click)="selecionarPeriodo(periodoBuscaEnum.DaSemana); aplicarPeriodo()"
                [class.periodo-item-selecionado]="periodoSelecionado === periodoBuscaEnum.DaSemana">
                <span>desta semana</span>
                @if (periodoSelecionado === periodoBuscaEnum.DaSemana) { <mat-icon>check</mat-icon> }
              </button>
              <button type="button" class="periodo-menu-item"
                (click)="selecionarPeriodo(periodoBuscaEnum.DoMes); aplicarPeriodo()"
                [class.periodo-item-selecionado]="periodoSelecionado === periodoBuscaEnum.DoMes">
                <span>do mês</span>
                @if (periodoSelecionado === periodoBuscaEnum.DoMes) { <mat-icon>check</mat-icon> }
              </button>
              <button type="button" class="periodo-menu-item"
                (click)="selecionarPeriodo(periodoBuscaEnum.Ultimos30Dias); aplicarPeriodo()"
                [class.periodo-item-selecionado]="periodoSelecionado === periodoBuscaEnum.Ultimos30Dias">
                <span>últimos 30 dias</span>
                @if (periodoSelecionado === periodoBuscaEnum.Ultimos30Dias) { <mat-icon>check</mat-icon> }
              </button>
              <button type="button" class="periodo-menu-item"
                (click)="selecionarPeriodo(periodoBuscaEnum.DoIntervalo); $event.stopPropagation()"
                [class.periodo-item-selecionado]="periodoSelecionado === periodoBuscaEnum.DoIntervalo">
                <span>do intervalo</span>
                @if (periodoSelecionado === periodoBuscaEnum.DoIntervalo) { <mat-icon>check</mat-icon> }
              </button>

              @if (periodoSelecionado === periodoBuscaEnum.DoIntervalo) {
              <div class="periodo-intervalo-fields" (click)="$event.stopPropagation()">
                <mat-form-field appearance="outline">
                  <mat-label>De</mat-label>
                  <input matInput [matDatepicker]="pickerDe" placeholder="DD/MM/AAAA" (input)="onDateInput($event)"
                    formControlName="dataDe">
                  <mat-datepicker-toggle matSuffix [for]="pickerDe"></mat-datepicker-toggle>
                  <mat-datepicker #pickerDe></mat-datepicker>
                  @if (model.get('dataDe')?.hasError('required')) {
                  <mat-error>Data inicial obrigatória</mat-error>
                  }
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Até</mat-label>
                  <input matInput [matDatepicker]="pickerAte" placeholder="DD/MM/AAAA" (input)="onDateInput($event)"
                    formControlName="dataAte">
                  <mat-datepicker-toggle matSuffix [for]="pickerAte"></mat-datepicker-toggle>
                  <mat-datepicker #pickerAte></mat-datepicker>
                  @if (model.get('dataAte')?.hasError('required')) {
                  <mat-error>Data final obrigatória</mat-error>
                  }
                  @if (model.get('dataAte')?.hasError('dataInvalida')) {
                  <mat-error>Data final menor que inicial</mat-error>
                  }
                  @if (model.get('dataAte')?.hasError('intervaloExcedido')) {
                  <mat-error>Intervalo máx. de {{ limiteMaxDias }} dias</mat-error>
                  }
                </mat-form-field>
                <div class="periodo-intervalo-actions">
                  <button type="button" mat-button class="btn-secondary"
                    (click)="cancelarPeriodoIntervalo(periodoMenuTrigger)">Cancelar</button>
                  <button type="button" mat-flat-button class="btn-primary"
                    (click)="aplicarPeriodo(periodoMenuTrigger)">Aplicar</button>
                </div>
              </div>
              }
            </div>
          </div>
        </mat-menu>
      </div>

      <!-- Tipo -->
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-6 col-sm-8">
        <mat-label>Tipo</mat-label>
        <mat-select formControlName="tipo">
          @for (t of tiposDisponiveis; track t.value) {
          <mat-option [value]="t.value">{{ t.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Pesquisa -->
      <mat-form-field appearance="outline" class="col-12">
        <mat-label>Pesquisar</mat-label>
        <input matInput formControlName="busca" (keyup.enter)="buscar()">
        <mat-icon matSuffix style="cursor:pointer" (click)="buscar()">search</mat-icon>
      </mat-form-field>

    </div>

    <!-- Limpar seleção -->
    @if (selecionados.size > 0) {
    <div class="limpar-selecao-wrapper">
      <button mat-button (click)="limparSelecao()">
        Limpar seleção
      </button>
    </div>
    }

  </div><!-- /dialog-fixed -->

  <!-- Seção scrollável: apenas a lista -->
  <div class="dialog-body">
    <div class="lista-container">
      @if (isLoading) {
      <div class="text-center py-4">
        <mat-spinner diameter="36" class="mx-auto"></mat-spinner>
      </div>
      } @else if (itens.length === 0) {
      <div class="text-center py-4">Nenhum registro encontrado.</div>
      } @else {
      @for (item of itens; track item.tipoMatch + '_' + item.idRegistro) {
      <div class="item-card mb-2" [class.item-card--selecionado]="isSelecionado(item)"
        (click)="toggleSelecionado(item)">
        <div class="item-check">
          <mat-checkbox color="primary" [checked]="isSelecionado(item)" (change)="toggleSelecionado(item)"
            (click)="$event.stopPropagation()">
          </mat-checkbox>
        </div>
        <div class="item-body">
          <div class="item-row-top">
            <span class="status-badge badge-cinza">{{ tipoLabel(item.tipoMatch) }}</span>
            <span class="item-data">{{ item.dataReferencia | date:'dd/MM/yyyy' }}</span>
          </div>
          <div class="item-descricao html-descricao-container" [innerHTML]="item.descricao"></div>
          @if (item.nomeEntidade) {
          <div class="item-entidade">{{ item.nomeEntidade }}</div>
          }
        </div>
        <div class="item-valor">
          <span>{{ item.valorEmAberto | abnt:'preco' }}</span>
          @if (item.valor !== item.valorEmAberto) {
          <span>de {{ item.valor | abnt:'preco' }}</span>
          }
        </div>
      </div>
      }
      }
      <!-- Ver Mais -->
      @if (!isLoading && itens.length > 0) {
      <div class="text-center mt-2">
        <button mat-button [disabled]="!_temMais || isLoadingMais" (click)="proximaPagina()">
          @if (isLoadingMais) {
          <mat-spinner diameter="20"></mat-spinner>
          } @else {
          <span class="material-symbols-outlined">expand_more</span>
          Ver Mais
          }
        </button>
      </div>
      }
    </div>
  </div><!-- /dialog-body -->

</div>